import { api } from "@/lib/api";
import {
  ReservationClientDto,
  reservationClientDtoListSchema,
  reservationClientFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";

export function getReservationClientsOptions(reservationId: string) {
  return queryOptions({
    queryKey: ["reservation-clients", reservationId],
    queryFn: async () => {
      const result: Array<ReservationClientDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.get(
          "/api/reservation-clients",
          reservationClientDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId: Number.parseInt(reservationId),
            },
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(reservationClientFromDto);
    },
  });
}

export function useGetReservationClients(reservationId: string) {
  return useQuery(getReservationClientsOptions(reservationId));
}
